import React from "react";
import SearchForm from "./SearchForm";
import Buttons from "./Buttons";
import Stories from "./Stories";

function App() {
  return (
    <>
      <SearchForm />
      <Buttons />
      <Stories />
    </>
  );
}

export default App;
